
import FormRow from 'modules/core/components/FormRow'
import DayPicker from 'modules/core/components/Inputs/DayPicker'
import RadioGroup from 'modules/core/components/Inputs/RadioGroup'
import i18n from 'modules/core/lib/i18n'

import type CompanyHolidayForm from 'modules/timeoff/lib/CompanyHoliday'
import CompanyHoliday from 'modules/timeoff/store/models/CompanyHoliday'

interface Props {
  form: CompanyHolidayForm
}

export function HalfDay({ form }: Props) {
  return (
    <FormRow multi>
      <DayPicker field={form.get('date')} label={i18n.t('settings.time_off.date')} />
      <RadioGroup
        name="halfDay"
        field={form.get('half_day')}
        options={[
          {
            value: CompanyHoliday.HalfDayTypes.beginning_of_day,
            label: i18n.t('time_off.half_day_options.first_half'),
          },
          {
            value: CompanyHoliday.HalfDayTypes.end_of_day,
            label: i18n.t('time_off.half_day_options.second_half'),
          },
        ]}
      />
    </FormRow>
  )
}
